import type { editor } from 'monaco-editor/esm/vs/editor/editor.api';

export class MonacoTheme {
    static json: editor.IStandaloneThemeData = {
        base: 'vs-dark',
        inherit: true,
        rules: [{ background: 'EDF9FA', token: "" }],
        "colors": {
            "focusBorder": "#75715e",
            "selection.background": "#ccccc7",
            "widget.shadow": "#000000",
            "input.background": "#0a0b09",
            "inputOption.activeBorder": "#75715e",
            "inputValidation.infoBackground": "#546190",
            "inputValidation.infoBorder": "#819aff",
            "inputValidation.warningBackground": "#848528",
            "inputValidation.warningBorder": "#e2e22e",
            "inputValidation.errorBackground": "#90274a",
            "inputValidation.errorBorder": "#f92672",
            "dropdown.background": "#414339",
            "list.focusBackground": "#414339",
            "list.activeSelectionBackground": "#75715e",
            "list.inactiveSelectionBackground": "#414339",
            "list.hoverBackground": "#272822",
            "list.dropBackground": "#414339",
            "list.highlightForeground": "#f8f8f2",
            "pickerGroup.foreground": "#75715e",
            "button.background": "#75715e",
            "badge.background": "#75715e",
            "badge.foreground": "#f8f8f2",
            "progressBar.background": "#75715e",
            "editor.foreground": "#efefef",
            "editorWidget.background": "#1e1f1c",
            "editor.selectionBackground": "#878b9180",
            "editor.selectionHighlightBackground": "#575b6180",
            "editorHoverWidget.background": "#414339",
            "editorHoverWidget.border": "#75715e",
            "diffEditor.insertedTextBackground": "#66852880",
            "diffEditor.removedTextBackground": "#90274a80",
            "editor.lineHighlightBackground": "#3e3d32",
            "editorCursor.foreground": "#f8f8f0",
            "editorWhitespace.foreground": "#464741",
            "editorIndentGuide.background": "#464741",
            "editorLineNumber.foreground": "#90908a",
            "editorSuggestWidget.background": "#272822",
            "editorSuggestWidget.border": "#75715e",
            "editor.wordHighlightBackground": "#4a4a7680",
            "editor.wordHighlightStrongBackground": "#6a6a9680",
            "peekViewTitle.background": "#1e1f1c",
            "peekView.border": "#75715e",
            "peekViewResult.background": "#1e1f1c",
            "peekViewResult.selectionBackground": "#414339",
            "peekViewEditor.background": "#272822",
            "peekViewResult.matchHighlightBackground": "#75715e",
            "peekViewEditor.matchHighlightBackground": "#75715e",
            "tab.inactiveBackground": "#171814",
            "tab.border": "#3d3e36",
            "tab.inactiveForeground": "#9f9f99",
            "editorGroupHeader.tabsBackground": "#0a0b09",
            "editorGroup.border": "#414339",
            "editorGroup.dropBackground": "#41433980",
            "panel.border": "#414339",
            "panelTitle.activeForeground": "#f8f8f2",
            "panelTitle.inactiveForeground": "#75715e",
            "panelTitle.activeBorder": "#f92672",
            "statusBar.foreground": "#90908a",
            "statusBar.background": "#0a0b09",
            "statusBar.noFolderBackground": "#0a0b09",
            "activityBar.background": "#0a0b09",
            "activityBar.foreground": "#90908a",
            "activityBar.dropBackground": "#414339",
            "activityBarBadge.background": "#f92672",
            "activityBarBadge.foreground": "#f6f6f4",
            "sideBar.background": "#171814",
            "sideBar.foreground": "#9f9f99",
            "sideBar.border": "#3d3e36",
            "sideBarTitle.foreground": "#e6db74",
            "sideBarSectionHeader.background": "#272822",
            "titleBar.activeForeground": "#9da5b4",
            "titleBar.activeBackground": "#0a0b09",
            "titleBar.inactiveBackground": "#272822",
            "statusBar.debuggingBackground": "#75715e",
            "debugToolBar.background": "#1e1f1c",
            "terminal.ansiBlack": "#333333",
            "terminal.ansiRed": "#c4265e",
            "terminal.ansiGreen": "#86b42b",
            "terminal.ansiYellow": "#b3b42b",
            "terminal.ansiBlue": "#6a7ec8",
            "terminal.ansiMagenta": "#8c6bc8",
            "terminal.ansiCyan": "#56adbc",
            "terminal.ansiWhite": "#e3e3dd",
            "terminal.ansiBrightBlack": "#666666",
            "terminal.ansiBrightRed": "#f92672",
            "terminal.ansiBrightGreen": "#a6e22e",
            "terminal.ansiBrightYellow": "#e2e22e",
            "terminal.ansiBrightBlue": "#819aff",
            "terminal.ansiBrightMagenta": "#ae81ff",
            "terminal.ansiBrightCyan": "#66d9ef",
            "terminal.ansiBrightWhite": "#f8f8f2"
        }
    }
}
